var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 287,
    viewBox: "0 0 176 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 183.314,
    y: 194.08,
    width: 226.607,
    height: 284.947,
    rx: 20,
    transform: "rotate(135 183.314 194.08)",
    fill: "url(#paint0_linear_466_603)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_466_603",
    x1: -1017.4,
    y1: -1291.38,
    x2: 12281.4,
    y2: 9123.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4259,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5584,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FFF2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7085,
    stopColor: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8693,
    stopColor: "#F4F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow);
export default __webpack_public_path__ + "static/media/yellow.a2d5f296d07ed55f51e826167a616178.svg";
export { ForwardRef as ReactComponent };